import { supabase } from "@/integrations/supabase/client";

interface CreateContributionParams {
  collection_id: string;
  amount: number;
  contributor_name: string;
  contributor_email: string;
  captcha_token: string;
}

export async function createContribution(params: CreateContributionParams) {
  const { data, error } = await supabase.functions.invoke(
    "create-contribution",
    { body: params },
  );
  return { data, error };
}

export async function getContributionsByCollection(collectionId: string) {
  const { data, error } = await supabase
    .from("contributions")
    .select("*")
    .eq("collection_id", collectionId)
    .order("created_at", { ascending: false });
  return { data, error };
}
